import AgentTile from 'sly/agentsRegionPage/AgentsRegionPageContent/AgentsRegionPageData/AgentsRegionPageAgents/AgentTile';

import { AgentsRegionPageDataAgentsProps } from './AgentRegionPageDataAgents.types';

export default function AgentsRegionPageAgents({
  agentsList,
}: AgentsRegionPageDataAgentsProps) {
  return (
    <div
      className='grid w-full grid-cols-[var(--col4)] justify-center gap-4 md:grid-cols-[var(--col4)_var(--col4)] lg:grid-cols-[var(--col4)_var(--col4)_var(--col4)]'
      data-tp-id='gen-div-4e8851cf-644b-498e-870f-0cf40baf4595'
    >
      {agentsList.map((agent) => (
        <AgentTile agent={agent} key={agent.id} />
      ))}
    </div>
  );
}
